<template>
	<b-modal id="account-login" v-model="show" no-fade hide-footer @show="listCharacters">
		<template v-slot:modal-header>
			<h5>Characters 
				<span class="badge badge-dark" v-if="characters.length <= 3">{{characters.length}}/3</span>
				<span class="badge badge-dark" v-else>{{characters.length}}</span>
			</h5>
			<b-button variant="default" size="sm" class="ml-2" @click="listCharacters">
				<font-awesome-icon icon="sync"></font-awesome-icon>
			</b-button>
			<b-button-close @click="show = false"/>
		</template>
		<div v-if="loading" class="text-center">
			<p><font-awesome-icon icon="spinner" pulse /> Loading...</p>
		</div>
		<div v-else-if="characters.length == 0">
			<p>It looks like you don't have any characters saved to your account.</p>
		</div>
		<b-media class="border-bottom py-1" v-else v-for="(character, characterIndex) in characters" :key="characterIndex">
			<template v-slot:aside>
				<b-img :src="character.image_uri" class="mr-3" :alt="character.name" style="max-width: 100px;"/>
			</template>
			<h5 class="mt-0">{{character.name}}</h5>
			<p class="mb-2"><i>{{character.desc}}</i></p>
			<div class="buttons">
				<span class="float-left">
					<button class="btn btn-sm btn-danger" @click="deleteCharacter(character.id, character.name)">Delete</button>
				</span>
				<span class="float-right">
					<button class="btn btn-sm btn-default" @click="listVersions(character.id)"><font-awesome-icon icon="history"></font-awesome-icon></button>
					<button class="btn btn-sm btn-primary" @click="loadCharacter(character.id)">Load</button>
				</span>
			</div>
		</b-media>
	</b-modal>
</template>

<script>
import Axios from "axios"

export default {
	data: function() {
		return {
			characters: [],
		}
	},
	computed: {
		show: {
			get: function(){
				return this.$store.state.characters.show
			},
			set: function(){
				this.$store.dispatch('characters/hide')
			}
		},
		loading: {
			get: function(){
				return this.$store.state.characters.loading
			},
			set: function(value){
				this.$store.dispatch('characters/setLoading',value)
			}
		}
		
	},
	methods: {
		listCharacters: function() {
			this.loading = true
			Axios.get('https://data.character.gallery/characters')
			.then( response => {
				this.characters = response.data.data
			})
			.finally( () => {
				this.loading = false
			})	
		},
		listVersions: function(characterID){
			this.$store.dispatch('characters/setCharacter',{
				id: characterID,
			})
			this.$store.dispatch('characters/showVersions')
		},
		loadCharacter: function(characterID){
			this.$store.dispatch('characters/load', {
				character: characterID,
			})
			this.loading = true
		},
		deleteCharacter: function(characterID, characterName){
			this.$store.dispatch('characters/delete', {
				id: characterID,
				name: characterName,
			})
			.finally(() => {
				this.listCharacters()
			})
		},
	},

}
</script>

<style scoped>

</style>